import { ViewAmostraAtual } from '@models/views/view-amostra-atual.model';
import { ViewEnsaioAtual } from '@models/views/view-ensaio-atual.model';
import { orderBy } from 'lodash';
import { EtapaAmostraLogEnum } from '../../../back/src/amostras/amostras.constants';
import { TipoEnsaioMetodoEnum } from '../../../back/src/ensaios-metodos/ensaios-metodos.constants';
import { StatusEnsaioEnum } from '../../../back/src/ensaios/ensaios.constants';

export enum StatusAmostraEnsaioEnum {
  CALCINACAO_PENDENTE = 'CALCINACAO_PENDENTE',
  CALCINACAO_INICIADA = 'CALCINACAO_INICIADA',
  CALCINACAO_COMPLETA = 'CALCINACAO_COMPLETA',
  UMIDADE_PENDENTE = 'UMIDADE_PENDENTE',
  UMIDADE_INICIADA = 'UMIDADE_INICIADA',
  UMIDADE_COMPLETA = 'UMIDADE_COMPLETA',
  AGUARDANDO_CRIACAO_ENSAIO = 'AGUARDANDO_CRIACAO_ENSAIO',
  SEM_ENSAIO = 'SEM ENSAIO',
  AGUARDANDO_FIRE_ASSAY = 'AGUARDANDO_FIRE_ASSAY',
  AGUARDANDO_PESAGEM_DILUICAO = 'AGUARDANDO_PESAGEM_DILUICAO',
  AGUARDANDO_ANALISE_ICP = 'AGUARDANDO_ANALISE_ICP',
  AGUARDANDO_ANALISE_ICP_COBRE = 'AGUARDANDO_ANALISE_ICP_COBRE',
  AGUARDANDO_PESAGEM_PEROLA = 'AGUARDANDO_PESAGEM_PEROLA',
  AGUARDANDO_ANALISE_UMIDADE = 'AGUARDANDO_ANALISE_UMIDADE',
  PENDENTE = 'PENDENTE',
}

export const etapaInfo = {
  // Comercial
  [EtapaAmostraLogEnum.CADASTRO_COMERCIAL]: {
    nome: 'Cadastro - Comercial',
    class: 'green--text',
  },
  // Utinga
  [EtapaAmostraLogEnum.CADASTRO_UTINGA]: {
    nome: 'Cadastro - Utinga',
    class: 'green--text',
  },
  [EtapaAmostraLogEnum.ENVIO_LABORATORIO_GUARULHOS]: {
    nome: 'Envio - Guarulhos',
    class: 'green--text',
  },
  // Guarulhos
  [EtapaAmostraLogEnum.CADASTRO_GUARULHOS]: {
    nome: 'Cadastro - Guarulhos',
    class: 'indigo--text',
  },
  [EtapaAmostraLogEnum.SOLICITACAO_ANALISE]: {
    nome: 'Solicitação de análise',
    class: 'indigo--text',
  },
  [EtapaAmostraLogEnum.RECEBIMENTO_LABORATORIO_GUARULHOS]: {
    nome: 'Recebimento - Guarulhos',
    class: 'indigo--text',
  },
  [EtapaAmostraLogEnum.ANALISE_LABORATORIO_GUARULHOS]: {
    nome: 'Análise - Guarulhos',
    class: 'indigo--text',
  },
  [EtapaAmostraLogEnum.ENVIO_LABORATORIO]: {
    nome: 'Envio - Laboratório',
    class: 'indigo--text',
  },
  // Vila Guilherme
  [EtapaAmostraLogEnum.RECEBIMENTO_PRODUCAO]: {
    nome: 'Recebimento - Produção',
    class: 'teal--text text--darken-3',
  },
  [EtapaAmostraLogEnum.COLETA_LABORATORIO]: {
    nome: 'Coleta - Laboratório',
    class: 'teal--text text--darken-3',
  },
  [EtapaAmostraLogEnum.RECEBIMENTO_LABORATORIO]: {
    nome: 'Recebimento - Laboratório',
    class: 'teal--text text--darken-3',
  },
  [EtapaAmostraLogEnum.ANALISE_LABORATORIO]: {
    nome: 'Análise - Laboratório',
    class: 'teal--text text--darken-3',
  },
  // Geral
  [EtapaAmostraLogEnum.FINALIZACAO]: {
    nome: 'Finalizada',
    class: 'success--text',
  },
  [EtapaAmostraLogEnum.REANALISE]: { nome: 'Reanálise', class: 'red--text' },
};

export const StatusAmostraEnsaio = {
  CALCINACAO_PENDENTE: {
    nome: 'Calcinação pendente',
    class: 'secondary--text text--lighten-2',
  },
  CALCINACAO_INICIADA: {
    nome: 'Calcinação iniciada',
    class: 'deep-orange--text text--darken-2',
  },
  CALCINACAO_COMPLETA: { nome: 'Calcinação completa', class: 'success--text' },
  UMIDADE_PENDENTE: {
    nome: 'Umidade pendente',
    class: 'secondary--text text--lighten-2',
  },
  UMIDADE_INICIADA: {
    nome: 'Umidade iniciada',
    class: 'cyan--text text--darken-2',
  },
  AGUARDANDO_CRIACAO_ENSAIO: {
    nome: 'Aguardando criação do ensaio',
    class: 'secondary--text text--lighten-2',
  },
  UMIDADE_COMPLETA: { nome: 'Umidade completa', class: 'success--text' },
  PENDENTE: { nome: 'Pendente', class: 'error--text text-body-2' },
  EM_ANDAMENTO: { nome: 'Em andamento', class: 'warning--text text-body-2' },
  FINALIZADO: { nome: 'Finalizado', class: 'success--text text-body-2' },
};

export function getEtapaNome(etapa: EtapaAmostraLogEnum): string {
  return etapaInfo?.[etapa]?.nome;
}
export function getEtapaClass(etapa: EtapaAmostraLogEnum): string {
  return etapaInfo?.[etapa]?.class;
}

export function getCalcinacao(amostra: ViewAmostraAtual): any {
  const ensaiosSorted: ViewEnsaioAtual[] = orderBy(
    amostra.ensaiosAtuais,
    ['createdAt'],
    ['desc'],
  );
  const ensaioCalcinacao = ensaiosSorted.find(
    (ensaio) =>
      ensaio.ensaioMetodoTipo === TipoEnsaioMetodoEnum.CALCINACAO &&
      ensaio.status === StatusEnsaioEnum.FINALIZADO,
  );
  return ensaioCalcinacao?.ensaiosAliquotasAtuais[0]
    .logResultadosAtualResultados;
}
export function getUmidade(amostra: ViewAmostraAtual): any {
  const ensaiosSorted: ViewEnsaioAtual[] = orderBy(
    amostra.ensaiosAtuais,
    ['createdAt'],
    ['desc'],
  );
  const ensaioUmidade = ensaiosSorted.find(
    (ensaio) =>
      ensaio.ensaioMetodoTipo === TipoEnsaioMetodoEnum.UMIDADE_ESTUFA &&
      ensaio.status === StatusEnsaioEnum.FINALIZADO,
  );
  return ensaioUmidade?.ensaiosAliquotasAtuais[0].logResultadosAtualResultados;
}

export function getStatusCalcinacao(status: StatusEnsaioEnum): string {
  if (status === StatusEnsaioEnum.FINALIZADO) {
    return StatusAmostraEnsaioEnum.CALCINACAO_COMPLETA;
  }
  if (status === StatusEnsaioEnum.EM_ANDAMENTO) {
    return StatusAmostraEnsaioEnum.CALCINACAO_INICIADA;
  }
  return StatusAmostraEnsaioEnum.CALCINACAO_PENDENTE;
}

export function getStatusUmidade(status: StatusEnsaioEnum): string {
  if (status === StatusEnsaioEnum.FINALIZADO) {
    return StatusAmostraEnsaioEnum.UMIDADE_COMPLETA;
  }
  if (status === StatusEnsaioEnum.EM_ANDAMENTO) {
    return StatusAmostraEnsaioEnum.UMIDADE_INICIADA;
  }
  return StatusAmostraEnsaioEnum.UMIDADE_PENDENTE;
}

export function getStatusOutros(amostra: ViewAmostraAtual): string {
  if (amostra.amostraUtinga?.semEnsaio) {
    return StatusAmostraEnsaioEnum.SEM_ENSAIO;
  }
  const ensaioCalcinacao = amostra.ensaiosAtuais.find(
    (ensaio) => ensaio.ensaioMetodoTipo === TipoEnsaioMetodoEnum.CALCINACAO,
  );
  const ensaioUmidade = amostra.ensaiosAtuais.find(
    (ensaio) => ensaio.ensaioMetodoTipo === TipoEnsaioMetodoEnum.UMIDADE_ESTUFA,
  );

  if (ensaioCalcinacao) {
    if (ensaioCalcinacao?.status === StatusEnsaioEnum.FINALIZADO) {
      return StatusAmostraEnsaioEnum.CALCINACAO_COMPLETA;
    }
    if (ensaioCalcinacao?.status === StatusEnsaioEnum.EM_ANDAMENTO) {
      return StatusAmostraEnsaioEnum.CALCINACAO_INICIADA;
    }
    return StatusAmostraEnsaioEnum.CALCINACAO_PENDENTE;
  } else if (ensaioUmidade) {
    if (ensaioUmidade?.status === StatusEnsaioEnum.FINALIZADO) {
      return StatusAmostraEnsaioEnum.UMIDADE_COMPLETA;
    }
    if (ensaioUmidade?.status === StatusEnsaioEnum.EM_ANDAMENTO) {
      return StatusAmostraEnsaioEnum.UMIDADE_INICIADA;
    }
    return StatusAmostraEnsaioEnum.UMIDADE_PENDENTE;
  } else {
    return StatusAmostraEnsaioEnum.AGUARDANDO_CRIACAO_ENSAIO;
  }
}

export function getStatusCalcinacaoNome(
  statusEnsaio: StatusEnsaioEnum,
): string {
  const status = getStatusCalcinacao(statusEnsaio);
  return StatusAmostraEnsaio?.[status]?.nome;
}

export function getStatusCalcinacaoClass(
  statusEnsaio: StatusEnsaioEnum,
): string {
  const status = getStatusCalcinacao(statusEnsaio);
  return StatusAmostraEnsaio?.[status]?.class;
}

export function getStatusUmidadeNome(statusEnsaio: StatusEnsaioEnum): string {
  const status = getStatusUmidade(statusEnsaio);
  return StatusAmostraEnsaio?.[status]?.nome;
}

export function getStatusUmidadeClass(statusEnsaio: StatusEnsaioEnum): string {
  const status = getStatusUmidade(statusEnsaio);
  return StatusAmostraEnsaio?.[status]?.class;
}

export function getStatusOutrosNome(amostra: ViewAmostraAtual): string {
  const status = getStatusOutros(amostra);
  return StatusAmostraEnsaio?.[status]?.nome;
}

export function getStatusOutrosClass(amostra: ViewAmostraAtual): string {
  const status = getStatusOutros(amostra);
  return StatusAmostraEnsaio?.[status]?.class;
}

export function getStatusEnsaio(ensaioAtual: ViewEnsaioAtual): string {
  switch (ensaioAtual.ensaioMetodoTipo) {
    case TipoEnsaioMetodoEnum.GRAVIMETRIA:
      return getStatusGravimetria(ensaioAtual);
    case TipoEnsaioMetodoEnum.ICP:
      return getStatusIcp(ensaioAtual);
    case TipoEnsaioMetodoEnum.ICP_COBRE:
      return getStatusIcpCobre(ensaioAtual);
    case TipoEnsaioMetodoEnum.FRX:
      return getStatusFrx(ensaioAtual);
    default:
      return StatusAmostraEnsaioEnum.PENDENTE;
  }
}

export function getStatusGravimetria(ensaioAtual: ViewEnsaioAtual): string {
  const temAliquotaSemPesoAmostra = ensaioAtual.ensaiosAliquotasAtuais.find(
    (aliquota) => !aliquota.logResultadosAtualResultados?.massaAmostraG,
  );
  if (ensaioAtual.status === StatusEnsaioEnum.PENDENTE) {
    return StatusAmostraEnsaioEnum.AGUARDANDO_FIRE_ASSAY;
  } else if (ensaioAtual.status === StatusEnsaioEnum.EM_ANDAMENTO) {
    if (temAliquotaSemPesoAmostra) {
      return StatusAmostraEnsaioEnum.AGUARDANDO_FIRE_ASSAY;
    } else {
      return StatusAmostraEnsaioEnum.AGUARDANDO_PESAGEM_PEROLA;
    }
  }
}

export function getStatusIcp(ensaioAtual: ViewEnsaioAtual): string {
  let indicadorAliquotasIncompletas = false;
  let indicadorIcpIncompleto = false;
  if (ensaioAtual.status === StatusEnsaioEnum.PENDENTE) {
    return StatusAmostraEnsaioEnum.AGUARDANDO_FIRE_ASSAY;
  } else if (ensaioAtual.status === StatusEnsaioEnum.EM_ANDAMENTO) {
    ensaioAtual.ensaiosAliquotasAtuais.forEach((aliquota) => {
      if (
        !aliquota.logResultadosAtualResultados?.massaPerolaMg ||
        !aliquota.logResultadosAtualResultados?.diluicaoMl
      ) {
        indicadorAliquotasIncompletas = true;
      }
      if (!aliquota.logResultadosAtualResultados?.concentracao) {
        indicadorIcpIncompleto = true;
      }
    });
    if (indicadorAliquotasIncompletas) {
      return StatusAmostraEnsaioEnum.AGUARDANDO_PESAGEM_DILUICAO;
    }
    if (indicadorIcpIncompleto) {
      return StatusAmostraEnsaioEnum.AGUARDANDO_ANALISE_ICP;
    }
  }
}

export function getStatusIcpCobre(ensaioAtual: ViewEnsaioAtual): string {
  let indicadorAliquotasIncompletas = false;
  let indicadorIcpIncompleto = false;
  if (ensaioAtual.status === StatusEnsaioEnum.PENDENTE) {
    return StatusAmostraEnsaioEnum.AGUARDANDO_PESAGEM_DILUICAO;
  } else if (ensaioAtual.status === StatusEnsaioEnum.EM_ANDAMENTO) {
    ensaioAtual.ensaiosAliquotasAtuais.forEach((aliquota) => {
      if (!aliquota.logResultadosAtualResultados?.diluicaoMl) {
        indicadorAliquotasIncompletas = true;
      }
      if (!aliquota.logResultadosAtualResultados?.concentracao) {
        indicadorIcpIncompleto = true;
      }
    });
    if (indicadorAliquotasIncompletas) {
      return StatusAmostraEnsaioEnum.AGUARDANDO_PESAGEM_DILUICAO;
    }
    if (indicadorIcpIncompleto) {
      return StatusAmostraEnsaioEnum.AGUARDANDO_ANALISE_ICP_COBRE;
    }
  }
}

export function getStatusFrx(ensaioAtual: ViewEnsaioAtual): string {
  if (ensaioAtual.status === StatusEnsaioEnum.PENDENTE) {
    if (!ensaioAtual?.amostraAtual?.umidade) {
      return StatusAmostraEnsaioEnum.AGUARDANDO_ANALISE_UMIDADE;
    }
    return StatusAmostraEnsaioEnum.PENDENTE;
  }
  return ensaioAtual.status;
}
